// extracted by mini-css-extract-plugin
export default {"container":"LeadingBadge-module__container--ZDh9V","titleLabel":"LeadingBadge-module__titleLabel--JQD9R","titleText":"LeadingBadge-module__titleText--p_nwt"};